<template>
  <div class="space-y-1">
    <div
        v-if="$slots.icon"
        :style="titleColor"
        class="text-3xl"
    >
      <slot name="icon"></slot>
    </div>
    <div
        class="text-xl font-semibold"
        :style="titleColor"
    >
      <slot></slot>
    </div>
    <div
        v-if="$slots.description"
        :style="textColor"
        class="text-lg"
    >
      <slot name="description"></slot>
    </div>
  </div>
</template>

<script>
import themeMixin from "../mixins/theme.mixin";

export default {
  name: "VTitleText",
  mixins: [themeMixin]
}
</script>

<style scoped>

</style>
